export const FRANCE_LOCALE = 'fr';
export const PRESCRIBER_CODE_ALLIANZ = 'ALL372764';
export const URL_PATH_ALLIANZ = '/allianz';
